import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";
import useTranslation from "../hooks/useTranslation";

export const SSOGeneralErrorPage: React.FC = () => {
  const navigation = useNavigation();
  const { t, m } = useTranslation();

  return (
    <InfoPage
      variant="warning"
      title={t(m.ErrorMessage.SSOGeneralError)}
      primaryCTA={
        <Button onClick={() => navigation.goToSignIn()}>{t(m.ErrorMessage.BackToLogin)}</Button>
      }
    />
  );
};
